<template>
  <div :id="questionId" :name="name" class="questionModel">
    <div>
      <table class="w-100">
        <tr height="30 px" class="mx-0 text-center align-middle" style="background-color: #f2effb">
          <b-col></b-col>
        </tr>
        <tr
          height="80 px"
          v-for="(label, idx) in columnLabels"
          :key="'label' + idx"
          class="p-0 text-nowrap text-center"
          :style="bgc[idx % 2]"
        >
          <td :id="questionId + '_value_' + (idx + 1)" class="align-middle">
            {{ columnLabels[idx] }}.
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'StaticColumn',
    props: ['label', 'name', 'answer', 'questionId', 'options'],
    data() {
      return {
        staticColumnId: '',
        columnLabels: [],
        bgc: [
          'background-color:#FAFAFA; color:#4B4B4B;',
          'background-color:#F6F4FF; color:#4B4B4B;',
        ],
      };
    },
    created() {
      this.staticColumnId = this.answer !== undefined ? this.answer[0]['Id'] : undefined;
      this.options.forEach(lov => {
        this.columnLabels.push(lov.Label__c);
      });
      this.$emit('input', {
        value: JSON.stringify(Object.assign({}, this.columnLabels)),
        id: this.staticColumnId,
      });
    },
  };
</script>
